import { useEffect, useState } from 'react';
import {
  Alert,
  Breadcrumb,
  Button,
  Divider,
  Flex,
  Tooltip,
  Typography,
} from 'antd';
import { EditOutlined, LeftOutlined } from '@ant-design/icons';

import OfferSetupGrid from '../OfferSetupGrid';
import StepProgressList from '../StepProgressList';
import ThirdPartyAlerts from '../ThirdPartyAlerts';
import {
  useRecoveriesState,
  goToPreviousStep,
  resetRecoveriesState,
  PAYMENT_PLAN_PROGRESS_STEPS,
  ONE_TIME_DEBIT_PROGRESS_STEPS,
  OPTIONAL_PAYMENT_PLAN_PROGRESS_STEPS,
} from './recoveriesState';

const { Title } = Typography;

const OfferSetup = ({
  renderStep,
  thirdParty,
  hasInitiatedSettlementOfferFromAppWeb,
}) => {
  const { currentStep, previousStep, stepIndex, offer } = useRecoveriesState();

  const [progressListDataSource, setProgressListDataSource] = useState([]);

  const getProgressListDataSource = () => {
    if (offer?.offerType?.includes('OneTimeDebit')) {
      return setProgressListDataSource(ONE_TIME_DEBIT_PROGRESS_STEPS);
    } else if (offer?.offerType?.includes('OptionalPaymentPlan')) {
      return setProgressListDataSource(OPTIONAL_PAYMENT_PLAN_PROGRESS_STEPS);
    }

    return setProgressListDataSource(PAYMENT_PLAN_PROGRESS_STEPS);
  };

  useEffect(() => {
    getProgressListDataSource();
  }, [offer]);

  return (
    <>
      <Breadcrumb
        style={{ marginBottom: 'var(--spacing-lg)' }}
        items={[{ title: 'Recoveries Home' }, { title: currentStep.title }]}
      />
      {hasInitiatedSettlementOfferFromAppWeb && (
        <Alert
          banner
          type="warning"
          showIcon
          style={{
            marginBottom: 'var(--spacing)',
            width: 725,
          }}
          title="Note: The customer has already made some progress towards accepting an offer. 
        Selecting an offer here will replace that offer and the customer will not be able to access it again."
        />
      )}
      <ThirdPartyAlerts thirdParty={thirdParty} />
      <OfferSetupGrid>
        {offer?.balance?.settlementBalance && (
          <div
            style={{ position: 'relative', paddingRight: 'var(--spacing-xs)' }}
          >
            <Flex justify="space-between" align="baseline">
              <Title level={5}>Program Set Up Progress </Title>
              <Tooltip title="Change Selected Offer">
                <Button
                  icon={<EditOutlined />}
                  type="text"
                  onClick={() => resetRecoveriesState()}
                >
                  Change Offer
                </Button>
              </Tooltip>
            </Flex>
            <StepProgressList
              steps={progressListDataSource}
              stepIndex={stepIndex}
            />
            <Divider
              orientation="vertical"
              style={{
                position: 'absolute',
                right: 'calc(-0.5 * var(--spacing) - var(--spacing-xs))',
                top: 0,
                height: '100%',
                margin: '0 var(--spacing-xs)',
              }}
            />
          </div>
        )}
        <div>{renderStep()}</div>
        {previousStep && (
          <div>
            <Button
              type="link"
              icon={<LeftOutlined />}
              onClick={goToPreviousStep}
              style={{ marginTop: 'var(--spacing-lg)', float: 'left' }}
            >
              {previousStep.title}
            </Button>
          </div>
        )}
      </OfferSetupGrid>
    </>
  );
};

export default OfferSetup;
